import { doLogout, setToken } from './auth';
import { BASE_URL } from '../config';

const BASE = (process.env.REACT_APP_API_BASE || BASE_URL || '').replace(/\/+$/, '');

export async function apiFetch(input, opts = {}, retry = true) {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const accountId = sessionStorage.getItem('accountId') || localStorage.getItem('accountId');
  const headers = Object.assign({}, opts.headers || {});
  // Filter out invalid token values
  if (token && token !== 'null' && token !== 'undefined' && token.trim() !== '') {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (accountId && accountId !== 'null' && accountId !== 'undefined' && String(accountId).trim() !== '') {
    headers['X-Author-Account-Id'] = String(accountId);
  }

  const res = await fetch(BASE + input, Object.assign({}, opts, { headers, credentials: 'include' }));
  if (res.status === 401) {
    // Try refresh once
    if (!retry) {
      doLogout();
      throw new Error('Unauthorized');
    }
    try {
      const r = await fetch(BASE + '/auth/refresh', { method: 'POST', credentials: 'include' });
      if (!r.ok) {
        doLogout();
        throw new Error('Refresh failed');
      }
      const j = await r.json();
      if (j.token) {
        setToken(j.token);
        // retry original request once
        const headers2 = Object.assign({}, opts.headers || {});
        headers2['Authorization'] = `Bearer ${j.token}`;
        if (accountId && accountId !== 'null' && accountId !== 'undefined' && String(accountId).trim() !== '') {
          headers2['X-Author-Account-Id'] = String(accountId);
        }
        const res2 = await fetch(BASE + input, Object.assign({}, opts, { headers: headers2, credentials: 'include' }));
        if (res2.status === 401) {
          doLogout();
          throw new Error('Unauthorized after refresh');
        }
        return res2;
      } else {
        doLogout();
        throw new Error('No token from refresh');
      }
    } catch (e) {
      doLogout();
      throw e;
    }
  }
  return res;
}
